type Values = { [key: string]: string | boolean | number }
type Errors = { [key: string]: string }

type Params = {
  values: Values
  validation: (_: Values) => Errors
  ignoredKeys?: string[]
  valuesStartEmpty?: boolean
}

export const shouldGrayOutCTACall = ({
  validation,
  values,
  ignoredKeys = [],
  valuesStartEmpty,
}: Params) => {
  // Testing the values object

  if (typeof values !== 'object') return false

  const valuesEntries = Object.entries(values)

  if (!valuesEntries.length && !valuesStartEmpty) return false

  const valuesResult = valuesEntries.reduce((prev, curr) => {
    if (ignoredKeys.includes(curr[0])) return prev

    return prev || !curr[1]
  }, false)

  if (valuesResult) return true

  // Testing schema validation

  const responseValidation = validation(values)

  if (!responseValidation || typeof responseValidation !== 'object') return false

  const entries = Object.entries(responseValidation)

  if (!entries.length) return false

  const result = entries.reduce((prev, curr) => {
    if (ignoredKeys.includes(curr[0])) return prev

    return prev || !!curr[1]?.length
  }, false)

  return result
}
